/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { EncounterStartType } from "./EncounterStartType";
import type { UniversalClinicVisitAssignee } from "./UniversalClinicVisitAssignee";
import type { UniversalClinicVisitStatus } from "./UniversalClinicVisitStatus";

/**
 * Response body from Universal Clinic for retrieving the status of a Curai encounter.
 */
export interface UniversalClinicVisitStatusResponse {
  /** The ID for the encounter associated with this visit. */
  encounter_id: string;
  /** The ID for the chat room used for this visit. */
  room_id: string;
  /** The ID for the external session associated with this visit. */
  external_session_id?: string | null;
  /** The current status of this visit. */
  status: UniversalClinicVisitStatus;
  /** The type of visit. */
  type?: EncounterStartType | null;
  /** The information of the clinician assigned to this visit, if any. Only relevant with the status is `IN_PROGRESS` or `COMPLETED`. */
  assigned_clinician?: UniversalClinicVisitAssignee | null;
  /** Whether or not this visit can be resumed by the patient. Only `true` when the status of this visit is `INCOMPLETE` and certain other internal criteria have been met. */
  can_be_resumed?: boolean;
}
